module.exports = __webpack_public_path__ + "img/81.80815c9.png";